import posthog from 'posthog-js';

const getToken = () => process.env.REACT_APP_POSTHOG_PROJECT_TOKEN;
const isReady = () => Boolean(getToken()) && Boolean(posthog.__loaded);
const isPresent = (value) => Boolean(value && String(value).trim());
const getValue = (user, key) =>
  user && typeof user.get === 'function' ? user.get(key) : user && user[key];

const getUserId = (user) => {
  const id = getValue(user, 'id');
  const objectId = getValue(user, '_id');
  return id || getValue(objectId, '$oid');
};

const getUserProperties = (user) => {
  const firstName = getValue(user, 'first_name');
  const lastName = getValue(user, 'last_name');
  const roles = getValue(user, 'roles');
  const properties = {
    email: getValue(user, 'email'),
    name: [firstName, lastName].filter(isPresent).join(' '),
    role:
      getValue(user, 'role') || (Array.isArray(roles) ? roles[0] : undefined),
    companyName: getValue(user, 'company_name'),
  };
  return Object.fromEntries(
    Object.entries(properties).filter(([, value]) => isPresent(value)),
  );
};

export const initPostHog = () => {
  if (!getToken() || posthog.__loaded) return;

  try {
    posthog.init(getToken(), {
      api_host:
        process.env.REACT_APP_POSTHOG_HOST || 'https://us.i.posthog.com',
      defaults: '2026-05-30',
      person_profiles: 'identified_only',
      autocapture: true,
      session_recording: { maskAllInputs: false },
      debug: process.env.NODE_ENV !== 'production',
    });
  } catch (error) {
    console.error('Unable to initialize PostHog', error);
  }
};

export const identifyUser = (user) => {
  const id = getUserId(user);
  if (!isReady() || !id) return;

  try {
    posthog.identify(id, getUserProperties(user));
  } catch (error) {
    console.error('Unable to identify PostHog user', error);
  }
};

export const resetPostHog = () => {
  if (!isReady()) return;

  try {
    posthog.reset();
  } catch (error) {
    console.error('Unable to reset PostHog', error);
  }
};
